import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Slice, GiftCardApplySlice } from './types'
import { setCart } from '../cart'
import { PWAThunk } from 'lib/core/data'

export const initialState: Slice = {}

interface ActionData {
  giftCard: string
}

const getSlice = (slice: GiftCardApplySlice): GiftCardApplySlice => {
  return slice ?? ({
    isFetching: false,
    isSuccess: false,
    isFailure: false
  })
}

const slice = createSlice({
  name: 'quote/giftCardApply',
  initialState,
  reducers: {
    request (state, action: PayloadAction<ActionData>) {
      const { giftCard } = action.payload
      const slice = getSlice(state[giftCard])
      slice.isFetching = true
      state[giftCard] = slice
    },

    success (state, action: PayloadAction<ActionData>) {
      const { giftCard } = action.payload
      const slice = getSlice(state[giftCard])
      slice.isFetching = false
      slice.isSuccess = true
      slice.isFailure = false
    },

    failure (state, action: PayloadAction<ActionData>) {
      const { giftCard } = action.payload
      const slice = getSlice(state[giftCard])
      slice.isFetching = false
      slice.isSuccess = false
      slice.isFailure = true
    }
  }
})

export const reducer = slice.reducer

export const { request, success, failure } = slice.actions

export function applyGiftCard (cartId: string, giftCard: string): PWAThunk {
  return async (dispatch, getState, params) => {
    const { magentoClient } = params
    dispatch(request({ giftCard }))
    try {
      const response = await magentoClient.getClient().quote.giftCardApply({
        cartId,
        giftCard
      })

      const { data } = response
      const { applyGiftCardToCart } = data
      const { cart } = applyGiftCardToCart

      if (cart) {
        dispatch(setCart({
          cartId,
          data: cart,
          merge: true
        }))
        dispatch(success({ giftCard }))
      } else {
        dispatch(failure({ giftCard }))
      }

      return response
    } catch (e) {
      dispatch(failure({ giftCard }))
    }
  }
}
